/* src/app/modules_v2/finance/financing-detail/financing-detail-panel.component.scss */
:host {
  display: block;
}
.fd-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.3fr);
  gap: 16px;
}
.fd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.fd-card__header,
.fd-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.fd-block__header {
  margin-bottom: 8px;
}
.fd-card__pills {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.fd-card__title,
.fd-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
}
.fd-card__title mat-icon,
.fd-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.fd-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.fd-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.fd-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.fd-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.fd-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.fd-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.fd-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.fd-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.fd-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.fd-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.fd-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.fd-line + .fd-line {
  border-top: 1px solid #eef1f4;
}
.fd-line__label {
  color: #6b7280;
}
.fd-line__value {
  font-weight: 600;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.fd-block {
  padding: 10px 0;
}
.fd-block + .fd-block {
  border-top: 1px solid #eef1f4;
}
.fd-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.fd-block__meta {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.fd-block__meta strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.fd-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.fd-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.fd-rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.fd-row {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
}
.fd-row:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.fd-row__date {
  color: #6b7280;
  white-space: nowrap;
}
.fd-row__main {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.fd-row__concept {
  color: #2f3540;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.fd-row__meta {
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
}
.fd-row__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.fd-row__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.fd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.fd-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.fd-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.fd-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.fd-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.fd-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.fd-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.fd-block__empty {
  padding: 6px 10px;
  font-size: 12px;
  color: #9ca3af;
  border: 1px dashed #e5e7eb;
  border-radius: 6px;
}
.fd-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.fd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.fd-empty .cf-btn {
  margin-left: auto;
}
.fd-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .fd-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .fd-row {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .fd-row__date {
    grid-column: 1/-1;
    font-size: 12px;
  }
  .fd-row__main {
    flex-direction: column;
    gap: 0;
  }
}
/*# sourceMappingURL=financing-detail-panel.component.css.map */
